import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getUserPlanAction = createAsyncThunk(
  "userPlan/getPlan",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(API_ENDPOINTS.USER_PLAN.GET);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateUserPlanAction = createAsyncThunk(
  "userPlan/updatePlan",
  async (planData, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.USER_PLAN.UPDATE,
        planData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const upgradeUserPlanAction = createAsyncThunk(
  "userPlan/upgradePlan",
  async (upgradeData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.USER_PLAN.UPGRADE,
        upgradeData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const downgradeUserPlanAction = createAsyncThunk(
  "userPlan/downgradePlan",
  async (downgradeData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.USER_PLAN.DOWNGRADE,
        downgradeData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
